/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import { Grid2, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import "./ApplicationDetailsVehicles.css";
import CloseIcon from "@mui/icons-material/Close";
import ApplicationModal from "../ApplicationModal/ApplicationModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

function ApplicationDetailsVehicles({
  vehicles,
  submissionData,
  postCallTheNewSubmission,
}) {
  const [vehc, setVehc] = useState([]);
  const [showVehicles, setShowVehicles] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const name = "Vehicles";

  const showDialog = () => {
    setOpenDialog(true);
  };

  const handleCancel = () => {
    setOpenDialog(false);
  };

  const handleOk = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    setVehc([...vehicles]);
    if (submissionData && Object.keys(submissionData).length > 0) {
      if (submissionData.targeting.vehiclesInclusions.length === 0) {
        let newSelected = [];
        let obj = {};
        obj["make"] = {
          id: null,
          all: true,
        };
        obj["model"] = {
          id: null,
          all: true,
        };
        obj["year"] = {
          id: null,
          all: true,
        };
        newSelected.push(obj);
        setShowVehicles([...newSelected]);
      } else if (submissionData.targeting.vehiclesInclusions.length === 1) {
        if (
          submissionData.targeting.vehiclesInclusions[0].make.all &&
          submissionData.targeting.vehiclesInclusions[0].model.all &&
          submissionData.targeting.vehiclesInclusions[0].year.all
        ) {
          setShowVehicles([...submissionData.targeting.vehiclesInclusions]);
        } else {
          const newVehiclesArray =
            submissionData.targeting.vehiclesInclusions.map((makeModelyear) => {
              let index = vehicles.findIndex(
                (vehicle) => makeModelyear.make.id === vehicle.id
              );
              if (index !== -1) {
                makeModelyear.make["name"] = vehicles[index].name;
                return makeModelyear;
              }
            });
          setShowVehicles([...newVehiclesArray]);
        }
      } else {
        const newVehiclesArray =
          submissionData.targeting.vehiclesInclusions.map((makeModelyear) => {
            let index = vehicles.findIndex(
              (vehicle) => makeModelyear.make.id === vehicle.id
            );
            if (index !== -1) {
              makeModelyear.make["name"] = vehicles[index].name;
              return makeModelyear;
            }
          });
        setShowVehicles([...newVehiclesArray]);
      }
    }
  }, [vehicles, submissionData]);

  const sendPostSubmissionCall = (selectedData) => {
    let newSubmissionData = { ...submissionData };
    newSubmissionData.targeting.vehiclesInclusions = [...selectedData];
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  return (
    <section className={(sessionStorage.getItem("isOemSeller") ||
                sessionStorage.getItem("idpLogin") == "true") ?"vehicles vehicles-no-border-bottom": "vehicles"}>
      <div className="wrapper-diver">
        <p className="text-title-vehicles">
          Make/Model/Year <span className="required">*</span>
        </p>
        <div style={{ marginTop: "6px !important" }}>
          {submissionData &&
          Object.keys(submissionData).length &&
          submissionData.status === "DRAFT" ? (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              Set
            </Button>
          ) : (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              View
            </Button>
          )}
        </div>
      </div>
      <div className="wrapper-diver">
        <div>
          <Stack direction="row" rowsGap={5} spacing={2}>
            <p className="vehiclesData">
              {submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.targeting.vehiclesInclusions.length !== 0 &&
              submissionData.targeting.vehiclesInclusions[0].make.all &&
              submissionData.targeting.vehiclesInclusions[0].model.all &&
              submissionData.targeting.vehiclesInclusions[0].year.all
                ? vehc.map((ele, index) => {
                    if (index < 21) {
                      return (
                        <Chip
                          sx={{
                            "font-weight": 400,
                            "font-size": "12px",
                            // "line-height": "19.6px",
                            // "letter-spacing": "0.4px",
                            color: "#5A5B5C",
                            "border-radius": "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                            height: "24px !important",
                          }}
                          key={ele.name}
                          id={index}
                          label={ele.name}
                          className="chip-text"
                          style={{
                            borderRadius: "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                          }}
                        ></Chip>
                      );
                    }
                  })
                : submissionData &&
                  Object.keys(submissionData).length > 0 &&
                  submissionData.targeting.vehiclesInclusions.length !== 0 &&
                  showVehicles &&
                  showVehicles.length > 0 &&
                  showVehicles.map((ele, index) => {
                    if (index < 21) {
                      return (
                        <Chip
                          sx={{
                            "font-weight": 400,
                            "font-size": "12px",
                            // "line-height": "19.6px",
                            // "letter-spacing": "0.4px",
                            color: "#5A5B5C",
                            "border-radius": "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                            height: "24px !important",
                          }}
                          key={ele.make.name}
                          id={index}
                          label={ele.make.name}
                          className="chip-text"
                          style={{
                            borderRadius: "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                          }}
                        ></Chip>
                      );
                    }
                  })}
              {submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.targeting.vehiclesInclusions.length !== 0 &&
              submissionData.targeting.vehiclesInclusions[0].make.all &&
              submissionData.targeting.vehiclesInclusions[0].model.all &&
              submissionData.targeting.vehiclesInclusions[0].year.all
                ? vehc &&
                  vehc.length > 20 && (
                    <Chip
                      sx={{
                        "font-weight": 400,
                        "font-size": "12px",
                        // "line-height": "19.6px",
                        // "letter-spacing": "0.4px",
                        color: "#5A5B5C",
                        "border-radius": "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                        height: "24px !important",
                      }}
                      id="see_more"
                      label="See More..."
                      style={{
                        fontSize: "12px",
                        border: 0,
                        backgroundColor: "white",
                        color: "#1565c0",
                      }}
                      onClick={showDialog}
                    ></Chip>
                  )
                : submissionData &&
                  Object.keys(submissionData).length > 0 &&
                  submissionData.targeting.vehiclesInclusions.length !== 0 &&
                  showVehicles &&
                  showVehicles.length > 20 && (
                    <Chip
                      sx={{
                        "font-weight": 400,
                        "font-size": "12px",
                        // "line-height": "19.6px",
                        // "letter-spacing": "0.4px",
                        color: "#5A5B5C",
                        "border-radius": "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                        height: "24px !important",
                      }}
                      id="see_more"
                      label="See More..."
                      style={{
                        fontSize: "12px",
                        border: 0,
                        backgroundColor: "white",
                        color: "#1565c0",
                      }}
                      onClick={showDialog}
                    ></Chip>
                  )}
            </p>
          </Stack>
        </div>
      </div>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
        maxWidth="xs"
        open={openDialog}
      >
        <DialogTitle>Make</DialogTitle>
        <DialogContent dividers>
          <Grid2 direction="row" rowsGap={5} spacing={2}>
            {submissionData &&
            Object.keys(submissionData).length > 0 &&
            submissionData.targeting.vehiclesInclusions.length !== 0 &&
            submissionData.targeting.vehiclesInclusions[0].make.all &&
            submissionData.targeting.vehiclesInclusions[0].model.all &&
            submissionData.targeting.vehiclesInclusions[0].year.all
              ? vehc.map((ele, index) => {
                  return (
                    <Chip
                      sx={{
                        "font-weight": 400,
                        "font-size": "12px",
                        // "line-height": "19.6px",
                        // "letter-spacing": "0.4px",
                        color: "#5A5B5C",
                        "border-radius": "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                        height: "24px !important",
                      }}
                      key={ele.name}
                      id={index}
                      label={ele.name}
                      className="chip-text"
                      style={{
                        borderRadius: "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                      }}
                    ></Chip>
                  );
                })
              : submissionData &&
                Object.keys(submissionData).length > 0 &&
                submissionData.targeting.vehiclesInclusions.length !== 0 &&
                showVehicles &&
                showVehicles.length > 0 &&
                showVehicles.map((ele, index) => {
                  return (
                    <Chip
                      sx={{
                        "font-weight": 400,
                        "font-size": "12px",
                        // "line-height": "19.6px",
                        // "letter-spacing": "0.4px",
                        color: "#5A5B5C",
                        "border-radius": "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                        height: "24px !important",
                      }}
                      key={ele.make.name}
                      id={index}
                      label={ele.make.name}
                      className="chip-text"
                    ></Chip>
                  );
                })}
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleOk}>Ok</Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 700, height: 460 }}>
          <h2 id="parent-modal-title">Targeting-make</h2>
          <div style={{ position: "absolute", right: "30px", top: "45px" }}>
            <IconButton>
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </div>
          <section>
            {showVehicles && showVehicles.length > 0 && (
              <ApplicationModal
                handleClose={handleClose}
                selectedData={showVehicles}
                availabilty={vehc}
                name={name}
                sendPostSubmissionCall={sendPostSubmissionCall}
                status={submissionData.status}
              />
            )}
          </section>
        </Box>
      </Modal>
    </section>
  );
}

ApplicationDetailsVehicles.propTypes = {
  vehicles: PropTypes.array.isRequired,
  submissionData: PropTypes.object.isRequired,
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default ApplicationDetailsVehicles;
